var map = {
	"./apple_logo.png": 71299,
	"./applestore.png": 63759,
	"./avatar.png": 78987,
	"./cecilian_logo.png": 41787,
	"./diamond_x2.png": 19044,
	"./event_no_image_placeholder.jpeg": 64489,
	"./google_logo.png": 48720,
	"./googleplay.png": 60415,
	"./image_not_available.png": 82562,
	"./lwr_registration.png": 68640,
	"./poi_heart.png": 28998
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90990;